import React, { useEffect, useState, useRef, useCallback } from 'react';
import { MDBSelect, MDBSpinner } from 'mdb-react-ui-kit';
import axios from 'axios';

const Drafters = ({ sessionId, selectedDrafter, setSelectedDrafter, setOffset, draftersCount }) => {
    const [drafters, setDrafters] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedOption, setSelectedOption] = useState("");
    const abortControllerRef = useRef(null);
    const [isSessionValid, setIsSessionValid] = useState(false);

    const validateSession = () => {
        if (sessionId && sessionId !== '') {
            setIsSessionValid(true);
        } else {
            setIsSessionValid(false);
        }
    };

    useEffect(() => {
        validateSession();
    }, [sessionId]);

    const fetchData = useCallback(async () => {
        if (!isSessionValid) return;

        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        const signal = abortControllerRef.current.signal;

        try {
            setIsLoading(true);
            let data;
            if (sessionId < 1000) {
                const response = await axios.get(`${process.env.REACT_APP_LAWS_BACKEND_HOST}/legislators/v1/staffMembers`, { signal });
                data = response.data.filter(item => item.title === "Deputy Research Director"
                    || item.title === "Legal Services Director"
                    || item.title === "Legislative Attorney"
                    || item.title === "Research Analyst"
                    || item.title === "Research Director");
            } else {
                const response = await axios.get(`${process.env.REACT_APP_LAWS_ARCHIVE_BACKEND_HOST}/v1/draftersBySession?sessionId=${sessionId}`, { signal });
                data = response.data;
            }
            let options = data.map(item => ({
                value: sessionId < 1000 ? item.id : item.entityIdSequence,
                text: `${item.lastName}, ${item.firstName}`
            }));
            options = options.filter((item, index, self) =>
                index === self.findIndex((t) => t.text === item.text)
            );
            options.sort((a, b) => a.text.localeCompare(b.text));
            options.unshift({ value: "0", text: "-- Select Drafters --", disabled: true });

            setDrafters(options);
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error('Error fetching data: ', error);
            }
        } finally {
            setIsLoading(false);
        }
    }, [sessionId, isSessionValid]);

    useEffect(() => {
        fetchData();

        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, [fetchData]);

    useEffect(() => {
        if(!selectedDrafter){
            setSelectedOption("0")
        }
    }, [selectedDrafter]);

    const handleDraftersSelect = (value) => {
        if (value === "0") {
            setSelectedOption(value);
            setSelectedDrafter([]);
        } else {
            const selectedValue = parseInt(value, 10);
            setSelectedOption(value);
            if (sessionId > 1000) {
                if (value) {
                    setSelectedOption(value);
                    setSelectedDrafter([]);
                } else {
                    setSelectedDrafter([]);
                }
            } else {
                setSelectedDrafter(selectedValue);
            }
        }
        setOffset(0);
    };

    return (
        <div className="mb-3 mt-4">
            {isLoading ? <p><MDBSpinner size='sm' role='status' tag='span' className='me-2' /> Loading...</p> :
                <MDBSelect
                    data={drafters}
                    id="drafterFilter"
                    search
                    clearBtn
                    value={selectedOption}
                    onValueChange={({ value }) => { handleDraftersSelect(value) }}
                />
            }
        </div>
    );
}

export default Drafters;